module.exports = __webpack_public_path__ + "img/category-sport-hover.0969edb5.png";